import Button from '@material-ui/core/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { makeStyles, useTheme } from '@material-ui/styles';
import React from 'react';
import PropTypes from '../../helpers/propTypes';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 290,
    width: '100%',
    textTransform: 'none',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },

    '& > span > :not(:last-child)': {
      marginRight: theme.direction === 'ltr' && '10px',
      marginLeft: theme.direction === 'rtl' && '10px',
    },
  },

  filler: {
    flex: '0 1 24px',
    display: 'block',
  },

  childContainer: {
    flexGrow: 1,
  },

  arrowLeft: {
    left: 5,
  },

  arrowRight: {
    right: 5,
  },
}));

function ButtonWithArrow({
  children,
  arrowSide,
  compact,
  hideText,
  ...buttonProps
}) {
  const classes = useStyles();

  return (
    <Button className={classes.root} {...buttonProps}>
      <ArrowSide arrowSide={arrowSide} compact={compact} hideText={hideText}>
        {children}
      </ArrowSide>
    </Button>
  );
}

function ArrowSide({ arrowSide, compact, hideText, children }) {
  const classes = useStyles();

  return (
    <>
      {arrowSide === 'left' ? (
        <ArrowSideLeft />
      ) : (
        !compact && <span className={classes.filler} />
      )}
      {!hideText && <div className={classes.childContainer}>{children}</div>}
      {arrowSide === 'right' ? (
        <ArrowSideRight />
      ) : (
        !compact && <span className={classes.filler} />
      )}
    </>
  );
}

function ArrowSideLeft() {
  const classes = useStyles();
  const theme = useTheme();

  return theme.direction === 'rtl' ? (
    <ArrowForward className={classes.arrowRight} />
  ) : (
    <ArrowBack className={classes.arrowLeft} />
  );
}

function ArrowSideRight() {
  const classes = useStyles();
  const theme = useTheme();
  return theme.direction === 'rtl' ? (
    <ArrowBack className={classes.arrowLeft} />
  ) : (
    <ArrowForward className={classes.arrowRight} />
  );
}

ArrowSide.propTypes = {
  arrowSide: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node.isRequired,
  compact: PropTypes.bool,
  hideText: PropTypes.bool,
};

ArrowSide.defaultProps = {
  arrowSide: 'right',
  compact: false,
  hideText: false,
};

ButtonWithArrow.propTypes = {
  arrowSide: PropTypes.oneOf(['left', 'right']),
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  compact: PropTypes.bool,
  hideText: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

ButtonWithArrow.defaultProps = {
  arrowSide: 'right',
  color: 'inherit',
  compact: false,
  hideText: false,
};

export default ButtonWithArrow;
